<template>
  <div class="feeling_main">
    <!-- 左侧列表 -->
    <div class="detail_left">
      <ul class="left_child">
        <li :class="activeName=== 'Positive'?'active':''" v-if="emotionData.emotionPositiveCount" @click="emotionClick('Positive')">
          正面（{{ emotionData.emotionPositiveCount }}）
        </li>
        <li :class="activeName=== 'Neutral'?'active':''" v-if="emotionData.emotionNeutralCount" @click="emotionClick('Neutral')">
          中性（{{ emotionData.emotionNeutralCount }}）
        </li>
        <li :class="activeName=== 'Negative'?'active':''" v-if="emotionData.emotionNegativeCount" @click="emotionClick('Negative')">
          负面（{{ emotionData.emotionNegativeCount }}）
        </li>
      </ul>
    </div>
    <!-- 右侧内容 -->
    <div class="detail_right">
      <div class="back">
        <span class="back_txt" @click="goBack">Back</span>
      </div>
      <!-- <div class="top_list">
        <span class="describe" v-for="(item, index) in siteData" :key="index"
          >{{ item.site }}：{{ item.count }}</span
        >
      </div> -->
      <el-tooltip placement="top-start" effect="dark">
        <span slot="content" class="tips-content text-tips-content">点击复制</span>
        <div
          class="top_list"
          v-clipboard:copy="siteData.map(item => { return `${item.site}:${item.count} `})"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError">
          <span
            v-for="(item, idx) in siteData"
            :key="idx"
            >{{ item.site }} : {{ item.count }} </span>
      </div>
      </el-tooltip>
      <!-- 新闻列表显示 -->
      <div class="cont_list">
        <div class="data_list" v-if="newsData && newsData.length > 0">
          <div class="news" v-for="(item, index) of newsData" :key="index">
            <!-- 品牌logo -->
            <div class="news_img">
              <div class="img_container">
                <img :src="item.logo" />
              </div>
            </div>
            <div class="news_content">
              <!-- 新闻标题 -->
              <div
                class="title text_one_line"
                @click="newContentDetail(item)"
                v-html="item.title"
              >
                {{ item.title }}
              </div>
              <!-- 新闻摘要 -->
              <div class="detail text_two_line" v-html="item.summary">
                {{ item.summary }}
              </div>
              <!-- 发布媒体 -->
              <div class="other_infor">
                <div class="new_author">
                  <span class="item_title">Source:</span>
                  <span class="item_detail">
                    {{item.site || 'None' }}
                  </span>
                </div>
                <!-- 发布时间 -->
                <div class="new_from">
                  <span class="item_title">Release time:</span>
                  <span class="item_detail color_alone">
                    {{ item.publish }}
                  </span>
                </div>
                <!-- 媒体所属国家 -->
                <div class="new_time">
                  <span class="item_title">{{ item.countryEN || 'None' }}</span>
                </div>
                <!-- 情感 -->
                <div class="new_time judge_btn">
                  <span class="show_btn">{{ item.emotion }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 分页 -->
      <el-pagination
        background
        layout="total,prev, pager, next"
        :total="totalNum"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { brandEomtionStatistics } from "@/common/js/http/version3Api.js";
import { Notification } from 'element-ui';
export default {
  data() {
    return {
      siteData: [],
      newsData: [],
      emotionData: {},
      startTime: "",
      endTime: "",
      isBack: true,
      currentPage: 1,
      pageSize: 5,
      totalNum: 0, //总页数为100
      // activeName: "Positive"
       activeName: this.$route.query.emotion ? this.$route.query.emotion : "Positive"
    };
  },
  created() {
    this.getFeelingList();
  },
  methods: {
    // 分页显示
    handleSizeChange(val) {
      this.pageSize = val;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getFeelingList(this.activeName)
    },
    async getFeelingList(param) {
      const emotion = param ? param : this.$route.query.emotion
      const form = {
        companyId: this.$route.query.companyId,
        emotion,
        region: this.$route.query.region,
        country: this.$route.query.country,
        site: this.$route.query.site,
        startTime: this.$route.query.startTime,
        endTime: this.$route.query.endTime,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
      };
      const res = await brandEomtionStatistics(form);
      if (res.code === 200) {
        this.emotionData = param ? this.emotionData : res.result.emotionMap;
        this.siteData = res.result.siteList;
        this.newsData = res.result.newsMap.newsList;
        this.totalNum = res.result.newsMap.totals
        this.pageSize = res.result.newsMap.pageSize
        // this.activeName = !param && this.emotionData.length > 0 ? this.emotionData[0].site : this.activeName;
      }
    },
    newContentDetail(row) {
      this.$router.push({
        name: "NewsDetail",
        query: {
          isBack: this.isBack,
          companyId: this.$route.query.companyId,
          id: row.id,
          site: this.$route.query.site,
          emotion: this.$route.query.emotion,
          topNum: row.topNum,
        },
      });
    },
    // 左侧情感点击事件
    async emotionClick(type) {
      //根据情感类型 动态分配 className，分别显示不同的样式
      this.activeName = type;
      // 每次点击切换的时候默认当前页为1
      this.currentPage = 1;
      const form = {
        companyId: this.$route.query.companyId,
        emotion: this.activeName,
        region: this.$route.query.region,
        country: this.$route.query.country,
        site: this.$route.query.site,
        startTime: this.$route.query.startTime,
        endTime: this.$route.query.endTime,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
      };
      const res = await brandEomtionStatistics(form);
      if (res.code === 200) {
        this.siteData = res.result.siteList;
        this.newsData = res.result.newsMap.newsList;
        this.totalNum = res.result.newsMap.totals
        this.pageSize = res.result.newsMap.pageSize
      }
    },
    // 返回
    goBack() {
      this.$router.push({
        name: "BrandCensus",
      });
    },
    onCopy(row) {
      Notification.info({
        title: '复制成功',
        message: '已复制到剪贴板,请直接去Ctrl+V粘贴吧',
        duration: 1500
      })
    },
    onError(row) {
      
    }
  },
};
</script>

<style scoped>
.feeling_main {
  width: 100%;
  height: 100%;
  padding: 10px;
  overflow: hidden;
}
.detail_left {
  width: 30%;
  height: 100%;
  float: left;
  border-right: 2px solid #ccc;
  overflow-y: auto;
}
.detail_left::-webkit-scrollbar,
.detail_right::-webkit-scrollbar {
  display: none;
}
.detail_left .left_child {
  height: auto;
}
.left_child li {
  padding: 10px;
  background: #fff;
  margin-bottom: 10px;
  cursor: pointer;
}

.left_child li.active {
  background-color:#208EFF;
  color: white;
  border-bottom:none;
}
.detail_right {
  width: calc(100% - 30%);
  height: 100%;
  float: right;
  padding: 0 10px;
  overflow-y: auto;
}
.detail_right .top_list{
  width: 100%;
  height: 20px;
  margin: 10px 0;
  overflow: hidden; /*超出部分隐藏*/
  text-overflow: ellipsis; /* 超出部分显示省略号 */
  white-space: nowrap; /*规定段落中的文本不进行换行 */
  vertical-align: bottom;
  cursor: pointer;
}
.describe {
  padding: 0 5px;
}
.detail_right .cont_list {
  /* height: calc(100% - 30px); */
  margin-bottom: 10px;
}
.data_list >>> .el-pagination {
  margin: 0 auto;
  text-align: center;
}
.news_source >>> .el-select > .el-input {
  width: 150px !important;
}
.date_search >>> .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 150px !important;
}
.date_search >>> .el-input--suffix .el-input__inner {
  padding-right: 20px !important;
}
.news_source >>> .news_input {
  display: inline-block;
  width: 270px;
}

.news_source >>> .el-input__inner,
.news_source >>> .el-input__icon {
  height: 32px;
  line-height: 32px;
}

.news {
  height: 168px;
  border-bottom: 1px solid #f3f4f5;
}

.news > div {
  display: inline-block;
  vertical-align: top;
}

.news_img {
  width: 145px;
  margin: 30px 0 15px;
  text-align: center;
}

.news_content {
  padding-top: 27px;
  width: calc(100% - 145px);
}

.img_container {
  width: 120px;
  height: 78px;
  line-height: 73px;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  overflow: hidden;
}

.img_container img {
  max-width: 100%;
}

.news .news_content .title {
  font-size: 18px;
  color: #9ca2b3;
  font-family: RCB;
  margin-bottom: 15px;
  cursor: pointer;
}

.news .news_content .title:hover {
  color: #4e5671;
}

.news .color_alone {
  color: #1a6bc5;
  font-family: RCR;
}
.item_detail {
  font-family: RCR;
  padding-right: 10px;
}
.news .news_content .detail {
  font-size: 13px;
  color: #6c757d;
  line-height: 20px;
  margin-bottom: 15px;
  font-family: RCR;
}
.other_infor > div {
  display: inline-block;
  vertical-align: middle;
  font-size: 12px;
  color: #6c757d;
}
/* .judge_btn {
  width: 40%;
  text-align: right;
} */
.show_btn {
  display: inline-block;
  border: 1px solid #ccc;
  padding: 1px 10px;
  border-radius: 7px;
  font-size: 10px;
}
.news_time {
  width: 100%;
  overflow: hidden; /*超出部分隐藏*/
  text-overflow: ellipsis; /* 超出部分显示省略号 */
  white-space: nowrap; /*规定段落中的文本不进行换行 */
  vertical-align: bottom;
}
.item_title {
  display: inline-block;
  font-size: 14px;
  color: #4e5671;
  font-family: RCB;
  margin-right: 10px;
}

.back {
  flex: 1;
  text-align: right;
  line-height: 26px;
}

.back_txt {
  padding: 5px 15px;
  border-radius: 15px;
  color: #8590a6;
  background: #f2f3f4;
  border: 1px solid rgba(0, 0, 0, 0);
  font-family: RCR;
  text-align: center;
  cursor: pointer;
}
</style>
